const MIN_E164_DIGITS = 7;
const MAX_E164_DIGITS = 15;

function digitsOnly(value: string): string {
  return value.replace(/\D/g, '');
}

export function isValidInternationalPhone(
  nationalNumber: string,
  callingCode: string
): boolean {
  const trimmedNumber = nationalNumber?.trim();
  if (!trimmedNumber) {
    return true;
  }

  if (!/^[\d\s().-]+$/.test(trimmedNumber)) {
    return false;
  }

  const nationalDigits = digitsOnly(trimmedNumber);
  const totalDigits = digitsOnly(callingCode).length + nationalDigits.length;

  return (
    nationalDigits.length > 0 &&
    totalDigits >= MIN_E164_DIGITS &&
    totalDigits <= MAX_E164_DIGITS
  );
}

export function getInternationalPhoneForSubmission(
  nationalNumber: string,
  callingCode: string
): string {
  const trimmedNumber = nationalNumber?.trim();
  return trimmedNumber ? `${callingCode} ${trimmedNumber}` : '';
}
